enum MembersTableMode {
  CURRENT_MEMBERS,
  PENDING_MEMBERS,
}
export default MembersTableMode;
